/**
 * Utilities for using {@link https://effect-ts.github.io/effect/docs/platform | \@effect/platform}.
 *
 * @module @sorrell/utilities/effect/platform
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./Platform.ts";
